import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
import classNames from "classnames";
import React, { memo } from "react";
import { getDaysUntilDue } from "../../../../utils";
import { t } from "i18next";
export var StatusBadge = /*#__PURE__*/memo(function (_ref) {
  var resolved = _ref.resolved,
    remind_after = _ref.remind_after;
  var _getDaysUntilDue = getDaysUntilDue(remind_after),
    dueInText = _getDaysUntilDue.text,
    daysRemaining = _getDaysUntilDue.daysRemaining;
  var classes = classNames("px-2 py-0.5 text-[12px] text-gray-100 rounded-full  whitespace-nowrap  min-w-[84px] text-center", _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "bg-green-600 border-green-700", resolved), "bg-yellow-600 border-yellow-700", !resolved && daysRemaining >= 0 && daysRemaining <= 7), "bg-red-600 border-red-700", !resolved && daysRemaining < 0), "border-gray-300 bg-gray-400", !resolved && daysRemaining > 7));
  var statusText = resolved ? t("key.task_status.done") : dueInText;
  return /*#__PURE__*/React.createElement("span", {
    className: classes
  }, statusText);
});
StatusBadge.displayName = "StatusBadge";